import React, { Component } from 'react'

import './buttons-row.styl'

type Props = {
  children: React.ReactNode
}

class ButtonsRow extends Component<Props> {
  render(): JSX.Element {
    return (
      <div className="buttons-row">
        <div className="buttons-row__container">{this.props.children}</div>
      </div>
    )
  }
}

export default ButtonsRow
